import { useTranslation } from 'react-i18next';

import { LuChevronUp, LuMail } from 'react-icons/lu';

import { SidebarRailTooltip } from '../../../../../SidebarRailTooltip/SidebarRailTooltip';

const stylesheet = {
  accordionButton:
    'flex w-full items-center justify-start py-0.5 pr-2 text-xs font-semibold tracking-widest uppercase text-semantic-text-secondary',
  accordionButtonChevron: 'h-3 w-3 transform transition-transform duration-200',
  accordionButtonChevronCollapsed: 'rotate-180',
  accordionButtonLabel: 'flex-1 text-left pl-[10px]',
  railToggle:
    'flex h-5 w-full items-center justify-center rounded-semantic text-semantic-text-secondary hover:bg-semantic-bg-hover',
  railToggleCollapsed:
    'flex items-center justify-center p-2 rounded-semantic hover:bg-semantic-bg-hover text-semantic-text-primary',
  contractedIcon: 'flex-shrink-0',
};

export interface InboxSectionHeaderProps {
  isSidebarOpen: boolean;
  isAccordionOpen: boolean;
  onToggleAccordion: () => void;
}

export function InboxSectionHeader({
  isSidebarOpen,
  isAccordionOpen,
  onToggleAccordion,
}: Readonly<InboxSectionHeaderProps>) {
  const { t } = useTranslation();

  if (isSidebarOpen) {
    const chevronClass = `${stylesheet.accordionButtonChevron}${!isAccordionOpen ? ` ${stylesheet.accordionButtonChevronCollapsed}` : ''}`;

    return (
      <button
        type="button"
        onClick={onToggleAccordion}
        className={stylesheet.accordionButton}
        aria-expanded={isAccordionOpen}
      >
        <span className={stylesheet.accordionButtonLabel}>
          {t('inbox.sidebar.inbox')}
        </span>
        <LuChevronUp className={chevronClass} />
      </button>
    );
  }

  const toggleLabel = t(
    isAccordionOpen
      ? 'inbox.sidebar.collapseMessages'
      : 'inbox.sidebar.expandMessages',
  );

  return (
    <SidebarRailTooltip label={toggleLabel}>
      <button
        type="button"
        onClick={onToggleAccordion}
        className={
          isAccordionOpen
            ? stylesheet.railToggle
            : stylesheet.railToggleCollapsed
        }
        aria-expanded={isAccordionOpen}
        aria-label={toggleLabel}
      >
        {isAccordionOpen ? (
          <LuChevronUp className={stylesheet.contractedIcon} />
        ) : (
          <LuMail className={stylesheet.contractedIcon} />
        )}
      </button>
    </SidebarRailTooltip>
  );
}
